var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0002C32 9.1208 27.658 3.25605 21.5652 0.995422V31.0051C27.658 28.7443 32 22.8797 32 16.0002V16.0002Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0002C0 22.8797 4.342 28.7443 10.4348 31.005V0.995422C4.342 3.25605 0 9.1208 0 16.0002V16.0002Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeru);
export default __webpack_public_path__ + "static/media/peru.7591f204.svg";
export { ForwardRef as ReactComponent };